// module imports
import Link from 'next/link';

// file imports
import { DataTable, PresentationActions } from '@/components';
import { formatDate } from '@/lib/helpers';
import { IPresentation } from '@/types';

interface EventsTableProps {
  events: IPresentation[];
  openDropdown: string | null;
  setOpenDropdown: (id: string | null) => void;
}

export default function PresentationsTable({ events, openDropdown, setOpenDropdown }: EventsTableProps) {
  const columns = [
    {
      key: 'date',
      label: 'Date',
      render: (presentation: IPresentation) => formatDate(presentation.date.toString()),
    },
    {
      key: 'title',
      label: 'Talk Title',
      render: (presentation: IPresentation) => (
        <div>
          <Link href={`/presentations/${presentation.slug}`} className="font-medium text-blue-600 hover:underline">
            {presentation.title}
          </Link>
          {presentation.tags && presentation.tags.length > 0 && (
            <div className="flex gap-1 mt-1">
              {presentation.tags.map((tag) => (
                <span key={tag} className="bg-gray-200 text-xs text-gray-700 px-2 py-0.5 rounded-full">
                  {tag}
                </span>
              ))}
            </div>
          )}
        </div>
      ),
    },
    { key: 'organization', label: 'Organization' },
    { key: 'presentationType', label: 'Presentation Type' },
    { key: 'category', label: 'Category' },
    {
      key: 'rate',
      label: 'Rate',
      render: (presentation: IPresentation) => (presentation.rate === 'Add' ? <button className="bg-gray-200 text-xs px-2 py-1 rounded hover:bg-gray-300 transition">Add</button> : presentation.rate || '-'),
    },
    { key: 'responses', label: 'Responses' },
    { key: 'leads', label: 'Leads' },
    {
      key: 'actions',
      label: 'Actions',
      render: (presentation: IPresentation) => <PresentationActions presentationSlug={presentation.slug || presentation._id || ''} isOpen={openDropdown === (presentation.slug || presentation._id)} onToggle={() => setOpenDropdown(openDropdown === (presentation.slug || presentation._id) ? null : presentation.slug || presentation._id || null)} responses={presentation.responses} />,
    },
  ];

  return <DataTable<IPresentation> data={events} columns={columns} emptyMessage="No presentations found. Create your first presentation to get started!" />;
}
